/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface GetTenantUsageStatisticsRequest {
    tenantId: string;
}

export interface GetUserUsageStatisticsRequest {
    userId: string;
}

export interface SetTenantQuotaRequest {
    tenantId: string;
    requestBody: { [key: string]: number; };
}

export interface SetTenantRateLimitRequest {
    tenantId: string;
    requestBody: { [key: string]: number; };
}

export interface SetUserQuotaRequest {
    userId: string;
    requestBody: { [key: string]: number; };
}

export interface SetUserRateLimitRequest {
    userId: string;
    requestBody: { [key: string]: number; };
}

/**
 * APIMeteringApi - interface
 * 
 * @export
 * @interface APIMeteringApiInterface
 */
export interface APIMeteringApiInterface {
    /**
     * Retrieves usage statistics for a specific tenant including usage count, quota, rate limit, and usage percentage.
     * @summary Get tenant-specific usage statistics
     * @param {string} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIMeteringApiInterface
     */
    getTenantUsageStatisticsRaw(requestParameters: GetTenantUsageStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieves usage statistics for a specific tenant including usage count, quota, rate limit, and usage percentage.
     * Get tenant-specific usage statistics
     */
    getTenantUsageStatistics(requestParameters: GetTenantUsageStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieves comprehensive API usage statistics including total usage, user counts, tenant counts, endpoint usage, and trends.
     * @summary Get overall API usage statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIMeteringApiInterface
     */
    getUsageStatisticsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieves comprehensive API usage statistics including total usage, user counts, tenant counts, endpoint usage, and trends.
     * Get overall API usage statistics
     */
    getUsageStatistics(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieves usage statistics for a specific user including usage count, quota, rate limit, and usage percentage.
     * @summary Get user-specific usage statistics
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIMeteringApiInterface
     */
    getUserUsageStatisticsRaw(requestParameters: GetUserUsageStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieves usage statistics for a specific user including usage count, quota, rate limit, and usage percentage.
     * Get user-specific usage statistics
     */
    getUserUsageStatistics(requestParameters: GetUserUsageStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Resets all API usage statistics to zero. Useful for testing or establishing new usage baselines.
     * @summary Reset all usage statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIMeteringApiInterface
     */
    resetUsageStatisticsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Resets all API usage statistics to zero. Useful for testing or establishing new usage baselines.
     * Reset all usage statistics
     */
    resetUsageStatistics(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Sets the API quota for a specific tenant.
     * @summary Set quota for a tenant
     * @param {string} tenantId 
     * @param {{ [key: string]: number; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIMeteringApiInterface
     */
    setTenantQuotaRaw(requestParameters: SetTenantQuotaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Sets the API quota for a specific tenant.
     * Set quota for a tenant
     */
    setTenantQuota(requestParameters: SetTenantQuotaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Sets the API rate limit for a specific tenant.
     * @summary Set rate limit for a tenant
     * @param {string} tenantId 
     * @param {{ [key: string]: number; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIMeteringApiInterface
     */
    setTenantRateLimitRaw(requestParameters: SetTenantRateLimitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Sets the API rate limit for a specific tenant.
     * Set rate limit for a tenant
     */
    setTenantRateLimit(requestParameters: SetTenantRateLimitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Sets the API quota for a specific user.
     * @summary Set quota for a user
     * @param {string} userId 
     * @param {{ [key: string]: number; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIMeteringApiInterface
     */
    setUserQuotaRaw(requestParameters: SetUserQuotaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Sets the API quota for a specific user.
     * Set quota for a user
     */
    setUserQuota(requestParameters: SetUserQuotaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Sets the API rate limit for a specific user.
     * @summary Set rate limit for a user
     * @param {string} userId 
     * @param {{ [key: string]: number; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIMeteringApiInterface
     */
    setUserRateLimitRaw(requestParameters: SetUserRateLimitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Sets the API rate limit for a specific user.
     * Set rate limit for a user
     */
    setUserRateLimit(requestParameters: SetUserRateLimitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class APIMeteringApi extends runtime.BaseAPI implements APIMeteringApiInterface {

    /**
     * Retrieves usage statistics for a specific tenant including usage count, quota, rate limit, and usage percentage.
     * Get tenant-specific usage statistics
     */
    async getTenantUsageStatisticsRaw(requestParameters: GetTenantUsageStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getTenantUsageStatistics().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/metering/tenant/{tenantId}/statistics`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves usage statistics for a specific tenant including usage count, quota, rate limit, and usage percentage.
     * Get tenant-specific usage statistics
     */
    async getTenantUsageStatistics(requestParameters: GetTenantUsageStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getTenantUsageStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves comprehensive API usage statistics including total usage, user counts, tenant counts, endpoint usage, and trends.
     * Get overall API usage statistics
     */
    async getUsageStatisticsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/metering/statistics`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves comprehensive API usage statistics including total usage, user counts, tenant counts, endpoint usage, and trends.
     * Get overall API usage statistics
     */
    async getUsageStatistics(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getUsageStatisticsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieves usage statistics for a specific user including usage count, quota, rate limit, and usage percentage.
     * Get user-specific usage statistics
     */
    async getUserUsageStatisticsRaw(requestParameters: GetUserUsageStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getUserUsageStatistics().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/metering/user/{userId}/statistics`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves usage statistics for a specific user including usage count, quota, rate limit, and usage percentage.
     * Get user-specific usage statistics
     */
    async getUserUsageStatistics(requestParameters: GetUserUsageStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getUserUsageStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Resets all API usage statistics to zero. Useful for testing or establishing new usage baselines.
     * Reset all usage statistics
     */
    async resetUsageStatisticsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/metering/reset`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Resets all API usage statistics to zero. Useful for testing or establishing new usage baselines.
     * Reset all usage statistics
     */
    async resetUsageStatistics(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.resetUsageStatisticsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Sets the API quota for a specific tenant.
     * Set quota for a tenant
     */
    async setTenantQuotaRaw(requestParameters: SetTenantQuotaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling setTenantQuota().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling setTenantQuota().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/metering/tenant/{tenantId}/quota`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Sets the API quota for a specific tenant.
     * Set quota for a tenant
     */
    async setTenantQuota(requestParameters: SetTenantQuotaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.setTenantQuotaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sets the API rate limit for a specific tenant.
     * Set rate limit for a tenant
     */
    async setTenantRateLimitRaw(requestParameters: SetTenantRateLimitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling setTenantRateLimit().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling setTenantRateLimit().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/metering/tenant/{tenantId}/rate-limit`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Sets the API rate limit for a specific tenant.
     * Set rate limit for a tenant
     */
    async setTenantRateLimit(requestParameters: SetTenantRateLimitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.setTenantRateLimitRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sets the API quota for a specific user.
     * Set quota for a user
     */
    async setUserQuotaRaw(requestParameters: SetUserQuotaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling setUserQuota().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling setUserQuota().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/metering/user/{userId}/quota`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Sets the API quota for a specific user.
     * Set quota for a user
     */
    async setUserQuota(requestParameters: SetUserQuotaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.setUserQuotaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sets the API rate limit for a specific user.
     * Set rate limit for a user
     */
    async setUserRateLimitRaw(requestParameters: SetUserRateLimitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling setUserRateLimit().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling setUserRateLimit().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/metering/user/{userId}/rate-limit`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Sets the API rate limit for a specific user.
     * Set rate limit for a user
     */
    async setUserRateLimit(requestParameters: SetUserRateLimitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.setUserRateLimitRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
